// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import PhotoWidget from '../../utils/FormWidgets/PhotoWidget';
import {
  getBase64,
  isMobileResolution,
} from '../../../infrastructure/utils/common';
import '../../../styles/containers/Parties.css';

class Cheatsheet {
  picture = '';
  title = '';
  subtitle = '';
}

class State {
  isNew = true;
  errorText = 'You can upload only png or jpg files';
  cheatsheet = new Cheatsheet();
}

export default class CheatsheetForm extends React.Component {
  state = new State();

  componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { cheatsheet } = this.props;
    if (cheatsheet) {
      this.setState({ cheatsheet, isNew: false });
    }
  }

  iconChange = async event => {
    const { target } = event;
    if (target.files.length === 0) {
      return;
    }
    if (
      target.files[0].type !== 'image/png' &&
      target.files[0].type !== 'image/jpeg'
    ) {
      // eslint-disable-next-line react/no-unused-state
      this.setState({ isError: true });
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      setTimeout(this.hideMessage, 5 * 1000);
      return;
    }
    const icon = await getBase64(target.files[0]);
    this.setState(prevState => {
      const cheatsheet = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.cheatsheet,
        picture: {
          isNew: true,
          blob: target.files[0],
          data: icon,
        },
      };
      return { cheatsheet };
    });
  };

  titleChange = ({ target }) => {
    this.setState(prevState => {
      const cheatsheet = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.cheatsheet,
        title: target.value,
      };
      return { cheatsheet };
    });
  };

  descriptionChange = ({ target }) => {
    this.setState(prevState => {
      const cheatsheet = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.cheatsheet,
        subtitle: target.value,
      };
      return { cheatsheet };
    });
  };

  validate = () => {
    const { cheatsheet } = this.state;
    return (
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      cheatsheet.picture.data &&
      cheatsheet.title.trim().length > 0 &&
      cheatsheet.subtitle.trim().length > 0
    );
  };

  submitElement = addElse => {
    const { cheatsheet } = this.state;
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { onSubmit } = this.props;
    const newCheatsheet = {
      ...cheatsheet,
      title: cheatsheet.title.trim(),
      subtitle: cheatsheet.subtitle.trim(),
    };
    if (addElse) {
      this.setState({ cheatsheet: new Cheatsheet() });
    }
    onSubmit(newCheatsheet, addElse, 'cheatsheet');
  };

  render() {
    const { cheatsheet, isNew } = this.state;
    const text = isNew ? 'Create' : 'Edit';
    const buttonText = isNew ? 'Create' : 'Update';
    const noDragnDrop = isMobileResolution();

    return (
      <Fragment>
        <h4 className='modal-head'>{text} cheatsheet</h4>
        <div className='media' style={{ marginBottom: '16px' }}>
          <div className='media-body' style={{ paddingTop: '15px' }}>
            <FormGroup style={{ paddingLeft: '0px' }}>
              <ControlLabel>Title</ControlLabel>
              <FormControl
                onChange={this.titleChange}
                value={cheatsheet.title}
              />
            </FormGroup>
          </div>
          <div
            className='media-right'
            style={{ verticalAlign: `${noDragnDrop ? 'bottom' : ''}` }}
          >
            <PhotoWidget
              header='Icon'
              onChange={this.iconChange}
              image={cheatsheet.picture}
              noDragnDrop={noDragnDrop}
            />
          </div>
          <div className='clearfix' />
        </div>
        <FormGroup style={{ marginBottom: '40px' }}>
          <ControlLabel>Description</ControlLabel>
          <FormControl
            componentClass='textarea'
            style={{ height: '100px' }}
            onChange={this.descriptionChange}
            value={cheatsheet.subtitle}
          />
        </FormGroup>
        <button
          type='button'
          className='btn btn-primary pull-right'
          disabled={!this.validate()}
          style={{ marginTop: '25px', marginRight: '0px' }}
          onClick={() => this.submitElement(false)}
          aria-label='left Align'
        >
          {buttonText}
        </button>
        {isNew && (
          <button
            type='button'
            className='btn btn-def pull-right'
            disabled={!this.validate()}
            style={{ marginTop: '25px', marginRight: '15px' }}
            onClick={() => this.submitElement(true)}
            aria-label='left Align'
          >
            Create and add else
          </button>
        )}
      </Fragment>
    );
  }
}
